"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInterestRate = void 0;
var getInterestRate = function (programs) {
    var allInterestRate = programs.flatMap(function (program) { return program.interest_rate; });
    return "".concat(Math.min.apply(Math, allInterestRate), "% - ").concat(Math.max.apply(Math, allInterestRate), "%");
};
exports.getInterestRate = getInterestRate;
